import { render } from "./uiContextMenu.vue?vue&type=template&id=5291f723&scoped=true"
import script from "./uiContextMenu.vue?vue&type=script&lang=js"
export * from "./uiContextMenu.vue?vue&type=script&lang=js"

import "./uiContextMenu.vue?vue&type=style&index=0&id=5291f723&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5291f723"]])

export default __exports__